module.exports = __webpack_public_path__ + "img/huawei.0c497306.svg";